import React, { useState } from 'react';
import './SettingReport.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../Config';
import { useAuth } from '../../AuthContext';

const SettingsPage = () => {
    const { user } = useAuth();
    const username = user.user;

    const [formData, setFormData] = useState({
        username: username.username || "",
        role: username.role || "",
        phonenumber: username.mobile || "",
        emailId: username.email || "",
        report: "",
      });
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };

      const handleSubmit = () => {
        // You can send the formData to your backend here
        axios
          .post(API_URL+'/submit', formData) // Define your backend URL and /submit endpoint
          .then((response) => {
            // Handle success
            console.log('Data sent successfully', response.data);
            window.alert('Report sent successfully')
            // Reset the form fields if needed
            setFormData({
              report: "",
            });
          })
          .catch((error) => {
            // Handle error
            console.error('Error sending data', error);
          });
      };

return (
        <div className="setting_report_page">
            <SideMenuBar />

            <div className="content">
                <NewHeader />

                <main className="setting_report_container">
                    <section className="setting_report_hero">
                        <div>
                            <span className="setting_report_kicker">Support & feedback</span>
                            <h1 className="setting_report_title">Settings</h1>
                            <p className="setting_report_subtitle">
                                Tell us about an issue, request or improvement you would like the team to review.
                            </p>
                        </div>

                        <div className="setting_report_status">
                            <span>Support channel</span>
                            <strong>Report an issue</strong>
                            <small>Your message will be sent to the support team.</small>
                        </div>
                    </section>

                    <section className="setting_report_panel">
                        <nav className="setting_report_tabs" aria-label="Settings sections">
                            <Link to="/SettingsPage" className="setting_report_tab">
                                Profile
                            </Link>
                            <Link to="/SettingPswd" className="setting_report_tab">
                                Password
                            </Link>
                            <Link to="/SettingReport" className="setting_report_tab active">
                                Report
                            </Link>
                        </nav>

                        <form
                            className="setting_report_form"
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleSubmit();
                            }}
                        >
                            <div className="setting_report_intro">
                                <span className="setting_report_eyebrow">New report</span>
                                <h2>Report a problem</h2>
                                <p>
                                    Provide the details below so the team can understand and respond to your request.
                                </p>
                            </div>

                            <div className="setting_report_grid">
                                <div className="setting_report_field">
                                    <label htmlFor="report-full-name">Full Name</label>
                                    <input
                                        id="report-full-name"
                                        placeholder="Enter full name"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="setting_report_field">
                                    <label htmlFor="report-role">Role</label>
                                    <input
                                        id="report-role"
                                        placeholder="Enter role"
                                        name="role"
                                        value={formData.role}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="setting_report_field">
                                    <label htmlFor="report-phone">Phone No.</label>
                                    <input
                                        id="report-phone"
                                        placeholder="Enter phone number"
                                        name="phonenumber"
                                        value={formData.phonenumber}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="setting_report_field">
                                    <label htmlFor="report-email">Email ID</label>
                                    <input
                                        id="report-email"
                                        type="email"
                                        placeholder="Enter email address"
                                        name="emailId"
                                        value={formData.emailId}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="setting_report_field setting_report_field_full">
                                    <div className="setting_report_label_row">
                                        <label htmlFor="report-description">Report</label>
                                        <span>Required</span>
                                    </div>
                                    <textarea
                                        id="report-description"
                                        placeholder="Describe the problem, request or feedback..."
                                        name="report"
                                        value={formData.report}
                                        onChange={handleInputChange}
                                    />
                                    <small>Include useful details such as what happened and where you noticed it.</small>
                                </div>
                            </div>

                            <footer className="setting_report_footer">
                                <span>Your report will be submitted securely to the support endpoint.</span>
                                <button type="submit" className="send_btn_SettingReport">
                                    Send report
                                </button>
                            </footer>
                        </form>
                    </section>
                </main>
            </div>
        </div>
    );
};

export default SettingsPage;